'use strict';

var _ = require('lodash');
var GridToolbarSystemStatusReoptimizationController = function GridToolbarSystemStatusReoptimizationController($scope) {
  $scope.isReoptimizeButtonShown = false;
  $scope.isCancelButtonShow = false;
  $scope.selectedRows = [];
  $scope.onRowSelection = function (selectedRows) {
    $scope.isReoptimizeButtonShown = selectedRows.length > 0;
    $scope.isCancelButtonShow = selectedRows.length > 0 && _.every(selectedRows, isNewOptimization);
    $scope.selectedRows = selectedRows;
  };
  $scope.reoptimize = function () {
    $scope.$emit('system-reoptimization-status:reoptimize', $scope.selectedRows);
  };
  $scope.cancelOptimization = function () {
    $scope.$emit('system-reoptimization-status:cancel', $scope.selectedRows);
  };
  function isNewOptimization(row) {
    return !!row.currentProcessingDay && !row.currentProcessingDay.processingStartDate;
  }
};
GridToolbarSystemStatusReoptimizationController.$inject = ['$scope'];
module.exports = GridToolbarSystemStatusReoptimizationController;